<h3>Exceptions</h3>
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      {{exceptions.length}}/{{totalExceptionCount}} elements
      <button type="button" class="btn btn-primary" (click)="loadData()">reload</button>
    </div>
    <div class="col-12">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Row</th>
            <th>Count</th>
            <th></th>
            <th>Exception</th>
            <th>Where</th>
            <th>Oldest</th>
            <th>Newest</th>
          </tr>
        </thead>
        <tbody>
          @for (exceptionGrp of exceptions; track exceptionGrp; let i = $index) {
            <tr (mouseenter)="hoveredIndex = i" (mouseleave)="hoveredIndex = undefined">
              <td (click)="showFull(content, exceptionGrp)">{{i}}</td>
              <td>{{exceptionGrp.length}}</td>
              <td><button type="button" (click)="accept(exceptionGrp, i)">X</button> </td>
              <td class="exception">{{exceptionGrp[0].second.stacktrace.substring(0, 400)}}</td>
              <td>{{getWhereOfGrp(exceptionGrp)}}</td>
              <td>{{getOldest(exceptionGrp)}}</td>
              <td>{{getNewest(exceptionGrp)}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">full exception</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="exception">{{modalExceptionText}}</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
